import React, { useState, useEffect } from 'react';
import './PlayerProfile.css';
import CONSTANTS, { computeBasedness, formatDate } from '../constants';
import { useLocation } from 'react-router-dom'; // <-- Changed from useParams
import { useNavigate } from 'react-router-dom';

function PlayerProfile(props) {
    const [playerScores, setPlayerScores] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    // Use the useLocation hook to get the current URL
    const location = useLocation();

    // Create a new URLSearchParams object with the search string
    const searchParams = new URLSearchParams(location.search);

    // Get the twitterUserName and transform it to uppercase
    const twitterUserName = searchParams.get('twitterUserName')

    async function fetchData() {
        if (!twitterUserName) return;

        let url = `${CONSTANTS.BACKEND_URL}?twitterUserName=${encodeURIComponent(twitterUserName)}`;
        console.log(url);
        try {
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            setPlayerScores(data);
            setLoading(false);
        } catch (error) {
            console.error("Error fetching player data:", error);
            setError(error);
            setLoading(false);
        }
    }
    
    useEffect(() => {
        fetchData();
    }, []);
    
    if (loading) return <div>Loading...</div>;
    if (error) return <div>Sorry - could not load Player Profile!</div>;

    return (
        <div className="player-profile-container">
            <div className="profile-header">
                <a href={`https://twitter.com/${encodeURIComponent(twitterUserName)}`} target="_blank" rel="noopener noreferrer">
                    <img src="/mfersbeheaded/images/twitter.png" alt="Twitter Logo" width="50" />
                </a>
                <h1 className="profile-title">{twitterUserName}</h1>
                <button onClick={() => navigate('/')} className="nav-button" style={{ backgroundColor: 'darkred' }}>Home</button>
            </div>

            <table className="player-profile">
                <thead>
                    <tr>
                    <th>Basedness Level</th>
                        <th>Date</th>
                        <th>Level</th>
                        <th>Score</th>
                    </tr>
                </thead>
                <tbody>
                    {playerScores.map((score, index) => {
                                    const [label, imageUrl] = computeBasedness(score.score.N, score.levelName.S);

                                    const levelNameStyle = {
                                        fontSize: score.levelName.S === 'Nakamigo Crush' ? '0.75em' : '0.9em',
                                        fontFamily: score.levelName.S === 'Nakamigo Crush' ? 'nakamigo, sans-serif' : 'Sartoshi, sans-serif'
                                    };
                        return (
                        <tr style={levelNameStyle} key={index}>
                                                                        <td>
                                                <img src={imageUrl} alt={label} width="50" />
                                            </td>
                            <td>{formatDate(score.date.S)}</td>
                            <td style={{ levelNameStyle }}>
                                {score.levelName.S === "Nakamigo Crush" ? "Pixel Crush" : score.levelName.S}
                            </td>
                            <td>{score.score.N}</td>
                        </tr>
                    );})}
                </tbody>
            </table>
        </div>
    );
}

export default PlayerProfile;